import React from 'react'
import CreateMultipleChoiceQuestionCard from '../components/QuestionsCreation/CreateMultipleChoiceQuestionCard'
import CreateDescriptiveQuestionCard from '../components/QuestionsCreation/CreateDescriptiveQuestionCard'
import CreateFreeResponseQuestionCard from '../components/QuestionsCreation/CreateFreeResponseQuestionCard'
import { SurveyItemQuestionType } from '../types'
import { StyledSelectQuestionWrapper } from '../SurveyCreateQuestions/styles'
import CreateLinearScaleCard from '../components/QuestionsCreation/CreateLinearScaleCard'
import { getSelectedQuestion, getSurveySections } from '../../../store/slices/SurveyTemplateSlice/selectors'
import CreateMultiSelectQuestionCard from '../components/QuestionsCreation/CreateMultiSelectQuestionCard'
import { type ISurveySection } from '../../../store/slices/SurveyTemplateSlice'

interface SurveyCreateQuestionsProps {
  sectionIndex: number
  section: ISurveySection
  isAdminAddedQuestion?: boolean
  isCountComplete?: boolean
}

const SurveyCreateQuestions: React.FC<SurveyCreateQuestionsProps> = ({ sectionIndex, section, isAdminAddedQuestion, isCountComplete }): JSX.Element => {
  const selectedQuestionType = getSelectedQuestion()
  const surveySectionsList = getSurveySections()
  const questionNumber = (surveySectionsList[sectionIndex].surveyItems?.length ?? 0) + 1

  const props = {
    questionNumber,
    sectionIndex,
    section,
    isAdminAddedQuestion,
    isCountComplete
  }

  const showCreateQuestionType = (): JSX.Element => {
    const key = selectedQuestionType?.question?.itemId
    switch (selectedQuestionType.questionType) {
      case SurveyItemQuestionType.MULTIPLE_CHOICE:
        return <CreateMultipleChoiceQuestionCard key={key} {...props} />
      case SurveyItemQuestionType.DESCRIPTIVE_TEXT:
        return <CreateDescriptiveQuestionCard key={key} {...props} />
      case SurveyItemQuestionType.FREE_RESPONSE:
        return <CreateFreeResponseQuestionCard key={key} {...props} />
      case SurveyItemQuestionType.LINEAR_SCALE:
        return <CreateLinearScaleCard key={key} {...props} />
      case SurveyItemQuestionType.MULTI_SELECT:
        return <CreateMultiSelectQuestionCard key={key} {...props} />
      default:
        return <></>
    }
  }
  return (
    <StyledSelectQuestionWrapper>
      {
        selectedQuestionType && sectionIndex === selectedQuestionType?.sectionIndex &&
        showCreateQuestionType()
      }
    </StyledSelectQuestionWrapper>
  )
}

export default SurveyCreateQuestions
